import {
  LineChart,
  Line,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  CartesianGrid,
} from 'recharts';
import { useTheme } from '@mui/material';

import {
  legendFormatter,
  tooltipFormatter,
  tooltipLabelFormatter,
  xAxisTickFormatter,
} from './metrics-chart.utils';
import { MetricsChartDataItemPaths, MetricsChartProps } from './metrics-chart.types';

export const MetricsChart = (props: MetricsChartProps) => {
  const { data } = props;
  const { palette } = useTheme();

  return (
    <ResponsiveContainer height={220}>
      <LineChart data={data}>
        {/*CartesianGrid should be placed before Line components*/}
        {/*So it does not overlap the lines*/}
        <CartesianGrid vertical={false} />
        <Line
          dataKey={'uniqueCodesShared' satisfies MetricsChartDataItemPaths}
          stroke={palette.ReferralProgramMetricsChart.uniqueCodesSharedColor}
          type='linear'
          dot={false}
        />
        <Line
          dataKey={'newMembersReferred' satisfies MetricsChartDataItemPaths}
          stroke={palette.ReferralProgramMetricsChart.newMembersReferredColor}
          type='linear'
          dot={false}
        />
        <Legend formatter={legendFormatter} iconType='square' verticalAlign='bottom' />
        <Tooltip formatter={tooltipFormatter} labelFormatter={tooltipLabelFormatter} />
        <XAxis
          dataKey={'date' satisfies MetricsChartDataItemPaths}
          tickFormatter={xAxisTickFormatter}
          tickLine={false}
          tick={{
            fill: palette.text.secondary,
            fontSize: '1rem',
          }}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{
            fill: palette.text.secondary,
            fontSize: '1rem',
          }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
